const themes = [
  'default',
  'starry-night',
  'violet-bloom',
  'neo-brutalism',
  'bubble-gum',
] as const;

export type ThemeKey = (typeof themes)[number];

export const availableThemes = Array.from(themes);

export default availableThemes;
